import { render } from "./AppliedFilters.vue?vue&type=template&id=0b2c4a7c"
import script from "./AppliedFilters.vue?vue&type=script&lang=js"
export * from "./AppliedFilters.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\floresn\\source\\repos\\igx-vue-park-list\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__